export const KIZUNA_DESIGNS = ["Checker", "Artisan", "Tweed"];
